import axios from "axios";
// [
//     {
//         "AxiosName": "Axios",
//         "URL": "http://172.16.10.5:4001"
//     }
// ]
//自定义axios
export default {
  install: async function(Vue, configPath) {
    Vue.prototype.CustAxios = {
      // config.sys路径，axios名，是否允许携带cookie
      CreateCustAxios: async function(
        configPath,
        axiosName,
        bWithCredentials = false
      ) {
        var res = await axios.get(configPath);
        //检查是否获取正确
        var url = "";
        if (res.status && res.status == 200) {
          if (res.data && res.data.length > 0) {
            var data = res.data;
            var len = res.data.length;
            for (var i = 0; i < len; i++) {
              if (data[i]["AxiosName"] == axiosName) {
                url = data[i]["URL"];
                break;
              }
            }
          }
        }

        //如果读取正确
        if (url.length > 0) {
          var baseUrlName = axiosName + "_BASE_URL";
          Vue.prototype[baseUrlName] = url;
          Vue.prototype[axiosName] = axios.create({
            baseURL: url,
            withCredentials: bWithCredentials, //允许携带cookie
            timeout: 20000,
          });
          //在向服务器请求前，先调用这个栏截器
          Vue.prototype[axiosName].interceptors.request.use((config) => {
            //显示请求头，可以在此处为请求头中加载token
            //
            config.headers.token = window.sessionStorage.getItem("token");
            //console.log('headers.token:',config.headers.token)
            return config;
          });
          Vue.prototype[axiosName].interceptors.response.use(
            (response) => {
              return response;
            },
            (error) => {
              var code = error.response.data.Code;
              var message = error.response.data.Message;
              if (code == 401) {
                console.log("code:", code + " message:" + message);
                //Vue.prototype.$toast(message);
                window.sessionStorage.clear();
                //this.$router.push('/Login');
                window.location.href = "#/Login"
                //Vue.prototype.$router.push("/Home");
                return;
              }
              return Promise.reject(error);
            }
          );
        } else {
          console.log("config文件读取失败");
        }

        return new Promise((resolve) => {
          resolve(url);
        });
      },
    };
  },
};
